export const ContactEntity = {
  MAX_ADDITIONAL_EMAILS_LENGTH: 1000,
}
